var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_11194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01126 6.76126C7.53871 6.23382 8.25408 5.9375 9 5.9375C9.74592 5.9375 10.4613 6.23382 10.9887 6.76126C11.5162 7.28871 11.8125 8.00408 11.8125 8.75C11.8125 9.49592 11.5162 10.2113 10.9887 10.7387C10.4613 11.2662 9.74592 11.5625 9 11.5625C8.25408 11.5625 7.53871 11.2662 7.01126 10.7387C6.48382 10.2113 6.1875 9.49592 6.1875 8.75C6.1875 8.00408 6.48382 7.28871 7.01126 6.76126ZM9 7.0625C8.55245 7.0625 8.12322 7.24029 7.80676 7.55676C7.49029 7.87322 7.3125 8.30245 7.3125 8.75C7.3125 9.19755 7.49029 9.62678 7.80676 9.94324C8.12322 10.2597 8.55245 10.4375 9 10.4375C9.44755 10.4375 9.87678 10.2597 10.1932 9.94324C10.5097 9.62678 10.6875 9.19755 10.6875 8.75C10.6875 8.30245 10.5097 7.87322 10.1932 7.55676C9.87678 7.24029 9.44755 7.0625 9 7.0625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.3125C7.92458 3.3125 6.87331 3.6314 5.97912 4.22886C5.08493 4.82633 4.38799 5.67554 3.97643 6.66909C3.56488 7.66265 3.45718 8.75594 3.66696 9.8107C3.87674 10.8654 4.39456 11.8343 5.15495 12.5947C5.15493 12.5947 5.15497 12.5948 5.15495 12.5947L8.3378 15.7768C8.51359 15.9524 8.7519 16.0511 9.00038 16.0511C9.24885 16.0511 9.48717 15.9524 9.66296 15.7768L12.845 12.5948C13.6054 11.8343 14.1233 10.8655 14.333 9.8107C14.5428 8.75594 14.4351 7.66265 14.0236 6.66909C13.612 5.67554 12.9151 4.82633 12.0209 4.22886C11.1267 3.6314 10.0754 3.3125 9 3.3125ZM5.35411 3.29346C6.4333 2.57238 7.70208 2.1875 9 2.1875C10.2979 2.1875 11.5667 2.57238 12.6459 3.29346C13.7251 4.01454 14.5662 5.03944 15.0629 6.23856C15.5596 7.43768 15.6896 8.75716 15.4364 10.0302C15.1832 11.3031 14.5583 12.4725 13.6405 13.3903L10.4583 16.5725C10.0715 16.9589 9.54703 17.1761 9.00038 17.1761C8.45373 17.1761 7.92944 16.9591 7.54271 16.5727L4.35955 13.3903C3.4418 12.4725 2.81676 11.3031 2.56357 10.0302C2.31039 8.75716 2.44037 7.43768 2.93708 6.23856C3.43379 5.03944 4.27492 4.01454 5.35411 3.29346Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_11194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.aedad4be75245fba4657177895d04199.svg";
export { ForwardRef as ReactComponent };